// package imports
import React from 'react';

// CSS imports
import './FlexSystemItem.css';

type Props = {
  children?: React.ReactNode;
  itemSize?: number;
};

const FlexSystemItem: React.FC<Props> = ({ children, itemSize }: Props) => {
  return (
    <div
      className={`FlexSystemItem ${
        itemSize === 1
          ? 'flex-item-1'
          : itemSize === 2
          ? 'flex-item-2'
          : itemSize === 3
          ? 'flex-item-3'
          : itemSize === 4
          ? 'flex-item-4'
          : itemSize === 5
          ? 'flex-item-5'
          : itemSize === 6
          ? 'flex-item-6'
          : itemSize === 7
          ? 'flex-item-7'
          : itemSize === 8
          ? 'flex-item-8'
          : itemSize === 9
          ? 'flex-item-9'
          : itemSize === 10
          ? 'flex-item-10'
          : itemSize === 11
          ? 'flex-item-11'
          : itemSize === 12
          ? 'flex-item-12'
          : ''
      }`}
    >
      {children ? children : null}
    </div>
  );
};

export default FlexSystemItem;
